var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdaptiveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 29,
    viewBox: "0 0 275 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipAdaptiveLogo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24435 28.3586L0.253906 0.68457H3.98214L7.24435 14.6713C8.04931 18.1359 8.76954 21.5577 9.27794 24.2524H9.36267C9.8287 21.515 10.676 18.2214 11.6081 14.6285L15.2516 0.68457H18.9375L22.2844 14.7141C23.047 18.0076 23.8096 21.3011 24.1909 24.2096H24.2756C24.8264 21.1728 25.6313 18.0931 26.4787 14.6285L30.0798 0.68457H33.681L25.9703 28.3586H22.2844L18.8104 13.9442C17.963 10.394 17.3699 7.69932 17.031 4.91908H16.9462C16.4379 7.65655 15.8447 10.394 14.8279 13.9442L10.9302 28.3586H7.24435Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2985 19.6329L40.4599 28.3586H36.8164L46.137 0.68457H50.416L59.7366 28.3586H55.966L53.0427 19.6329H43.2985ZM52.2801 16.8527L49.611 8.89696C49.0179 7.1005 48.5942 5.43236 48.1706 3.84976H48.0859C47.6622 5.47513 47.2385 7.18604 46.6878 8.85419L44.0187 16.8527H52.2801Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8618 3.72144H61.5156V0.68457H81.8091V3.72144H73.4206V28.3586H69.8618V3.72144Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509 27.4174C105.196 28.059 102.611 28.7434 99.2643 28.7434C91.5536 28.7434 85.707 23.8245 85.707 14.7566C85.707 6.07375 91.5112 0.213867 100.027 0.213867C103.459 0.213867 105.619 0.941006 106.551 1.45428L105.704 4.36283C104.348 3.72124 102.442 3.20797 100.154 3.20797C93.7143 3.20797 89.4776 7.35694 89.4776 14.6283C89.4776 21.3864 93.333 25.7493 100.027 25.7493C102.188 25.7493 104.391 25.2788 105.789 24.5944L106.509 27.4174Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509 27.4174C105.196 28.059 102.611 28.7434 99.2643 28.7434C91.5536 28.7434 85.707 23.8245 85.707 14.7566C85.707 6.07375 91.5112 0.213867 100.027 0.213867C103.459 0.213867 105.619 0.941006 106.551 1.45428L105.704 4.36283C104.348 3.72124 102.442 3.20797 100.154 3.20797C93.7143 3.20797 89.4776 7.35694 89.4776 14.6283C89.4776 21.3864 93.333 25.7493 100.027 25.7493C102.188 25.7493 104.391 25.2788 105.789 24.5944L106.509 27.4174Z",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509 27.4174C105.196 28.059 102.611 28.7434 99.2643 28.7434C91.5536 28.7434 85.707 23.8245 85.707 14.7566C85.707 6.07375 91.5112 0.213867 100.027 0.213867C103.459 0.213867 105.619 0.941006 106.551 1.45428L105.704 4.36283C104.348 3.72124 102.442 3.20797 100.154 3.20797C93.7143 3.20797 89.4776 7.35694 89.4776 14.6283C89.4776 21.3864 93.333 25.7493 100.027 25.7493C102.188 25.7493 104.391 25.2788 105.789 24.5944L106.509 27.4174Z",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509 27.4174C105.196 28.059 102.611 28.7434 99.2643 28.7434C91.5536 28.7434 85.707 23.8245 85.707 14.7566C85.707 6.07375 91.5112 0.213867 100.027 0.213867C103.459 0.213867 105.619 0.941006 106.551 1.45428L105.704 4.36283C104.348 3.72124 102.442 3.20797 100.154 3.20797C93.7143 3.20797 89.4776 7.35694 89.4776 14.6283C89.4776 21.3864 93.333 25.7493 100.027 25.7493C102.188 25.7493 104.391 25.2788 105.789 24.5944L106.509 27.4174Z",
    stroke: "url(#paint1_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.117 0.68457V12.276H131.378V0.68457H134.937V28.3586H131.378V15.3557H118.117V28.3158H114.559V0.68457H118.117Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.152 28.3586L154.213 0.68457H158.026L162.305 14.3291C163.491 18.0503 164.508 21.4294 165.228 24.6801H165.313C166.075 21.4722 167.219 18.0076 168.448 14.3719L171.032 6.71554L174.718 6.67277L167.05 28.3586H163.152Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14 19.6329L182.302 28.3586H178.658L187.979 0.68457H192.258L201.621 28.3586H197.85L194.927 19.6329H185.14ZM194.122 16.8527L191.453 8.89696C190.86 7.1005 190.436 5.43236 190.012 3.84976H189.928C189.504 5.47513 189.08 7.18604 188.53 8.85419L185.86 16.8527H194.122Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.578 0.68457V17.0666C211.578 23.2686 214.289 25.8778 217.975 25.8778C222.042 25.8778 224.627 23.1831 224.627 17.0666V0.68457H228.185V16.8099C228.185 25.3217 223.737 28.7863 217.806 28.7863C212.213 28.7863 207.977 25.5356 207.977 16.981V0.68457H211.578Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.973 0.68457H241.531V25.3645H253.225V28.3586H237.973V0.68457Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84 3.72144H254.494V0.68457H274.788V3.72144H266.399V28.3586H262.84V3.72144Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 96.1291,
    y1: 0.213867,
    x2: 96.1291,
    y2: 28.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentcolor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentcolor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 96.1291,
    y1: 0.213867,
    x2: 96.1291,
    y2: 28.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentcolor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentcolor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipAdaptiveLogo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 29,
    fill: "currentcolor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptiveLogo);
export default __webpack_public_path__ + "static/media/adaptiveLogo.6966e5c2.svg";
export { ForwardRef as ReactComponent };